import React, { useState, useEffect } from 'react';
import OverallProgressReport from '../components/Reports/OverallProgressReport';
import CustomerProgressReport from '../components/Reports/CustomerProgressReport';
import { getCustomers } from '../services/customerService';

/**
 * Reports page component
 */
const Reports: React.FC = () => {
  const [selectedCustomerId, setSelectedCustomerId] = useState<string>('');
  const [customers, setCustomers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [viewType, setViewType] = useState<'overall' | 'customer'>('overall');

  // Fetch customers when component mounts
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        setLoading(true);
        const customers = await getCustomers();
        setCustomers(customers || []);
      } catch (error) {
        console.error('Error fetching customers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomers();
  }, []);

  // Handle view type change
  const handleViewTypeChange = (type: 'overall' | 'customer') => {
    setViewType(type);
  };

  return (
    <div className="page-container">
      <h1 className="page-title">Progress Reports</h1>
      
      <div className="card mb-lg">
        <div className="mb-md">
          <div className="flex gap-sm mb-md">
            <button 
              onClick={() => handleViewTypeChange('overall')}
              className={viewType === 'overall' ? 'btn btn-primary' : 'btn btn-secondary'}
            >
              Overall Report
            </button>
            <button 
              onClick={() => handleViewTypeChange('customer')}
              className={viewType === 'customer' ? 'btn btn-primary' : 'btn btn-secondary'}
            >
              Customer Report
            </button>
          </div>
          
          {viewType === 'customer' && (
            <div className="mb-md">
              <label htmlFor="customerSelect" className="mb-xs">
                Select Customer:
              </label>
              <select
                id="customerSelect"
                value={selectedCustomerId}
                onChange={(e) => setSelectedCustomerId(e.target.value)}
                className="p-sm"
                style={{ width: '100%', maxWidth: '400px' }}
              >
                <option value="">-- Select a customer --</option>
                {loading ? (
                  <option disabled>Loading customers...</option>
                ) : (
                  customers.map((customer) => (
                    <option key={customer.customerId} value={customer.customerId}>
                      {customer.customerName} ({customer.customerNumber})
                    </option>
                  ))
                )}
              </select>
            </div>
          )}
        </div>
        
        <div>
          {viewType === 'overall' ? (
            <OverallProgressReport />
          ) : (
            selectedCustomerId ? (
              <CustomerProgressReport customerId={selectedCustomerId} />
            ) : (
              <div className="p-md text-secondary">Please select a customer to view their progress report.</div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Reports;
